import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import useWindowSize from '../../utils/useWindowSize'; // 1. Importamos el hook

ChartJS.register(ArcElement, Tooltip, Legend);

function StudyTimeDoughnutChart({ studyTimeBreakdown = [] }) {
    const { width } = useWindowSize(); // 2. Obtenemos el ancho de la pantalla
    const isMobile = width < 768;
    
    const data = {
        labels: studyTimeBreakdown.map(item => item.skill_name),
        datasets: [{
            label: ' Segundos de Estudio',
            data: studyTimeBreakdown.map(item => item.total_seconds),
            backgroundColor: [
                '#9333ea', // Morado (Speaking)
                '#facc15', // Amarillo (Vocabulary)
                '#06b6d4', // Cian (Grammar)
                '#4ade80', // Verde (Listening)
                '#f97316', // Naranja (Reading)
                '#ec4899', // Rosa (Writing)
            ],
            borderColor: 'var(--bg-primary)',
            borderWidth: 2,
        }]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '70%',
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    // 3. Hacemos la fuente de la leyenda más pequeña en móvil
                    color: 'var(--text-secondary)',
                    padding: 15,
                    font: { 
                        size: isMobile ? 10 : 12, 
                        family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" 
                    }
                }
            }
        }
    };
    
    return <Doughnut data={data} options={options} />;
}

export default StudyTimeDoughnutChart;
